<div class="card overflow-hidden">
  <div class="px-gutter py-4 border-b">
    <div class="flex items-center gap-2">
      <h2 class="title m-0">Équipes ({{ rows.length }})</h2>
      <team-action-mock-new [show]="settings.showNew"></team-action-mock-new>
    </div>
    <p *ngIf="fictive" class="m-0 caption text-secondary">Maquette : données fictives</p>
  </div>
  <table mat-table [dataSource]="rows" class="w-full shadow-none">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Équipe</th>
      <td mat-cell *matCellDef="let row">{{ row.team.name }}</td>
    </ng-container>
    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>Rôle</th>
      <td mat-cell *matCellDef="let row" class="text-secondary">{{ row.team.role }}</td>
    </ng-container>
    <ng-container matColumnDef="support">
      <th mat-header-cell *matHeaderCellDef>Établissement support</th>
      <td mat-cell *matCellDef="let row" class="text-secondary">{{ row.team.support.name }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" class="text-right">
        <mat-icon *ngIf="row.issue" class="text-warn" [matTooltip]="row.issue">error</mat-icon>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr
      mat-row
      *matRowDef="let row; columns: displayedColumns"
      [class.cursor-pointer]="linkable"
      (click)="open(row)"
    ></tr>
  </table>
</div>
